if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener( 'modalClosed', () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            const element = document.querySelector('#js-shipping-timer');
const disableNextDay = false;
const getshipping_time_exclude = document.querySelector('.shipping_time_exclude');
const getorder_within = document.querySelector('.order-within');
const getshipping_time = document.querySelector('.shipping-time');

// Hardcoded time zone for Central Time (Chicago)
const timeZone = 'America/Chicago';
// const timeZone = 'America/New_York';

const cutoffHour = getorder_within
  ? parseInt(getorder_within.innerText)
  : 17;

const excludedDates = getshipping_time_exclude
  ? [getshipping_time_exclude.innerText]
  : [];

function getDateInTimeZone(timeZone) {
  const now = new Date();
  const options = {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };
  const formatter = new Intl.DateTimeFormat('en-CA', options);
  const parts = formatter.formatToParts(now).reduce((acc, part) => {
    if (part.type !== 'literal') acc[part.type] = part.value;
    return acc;
  }, {});
  const isoString = `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`;
  return new Date(isoString);
}

function getTimeLeft(diffInSeconds) {
  const hours = parseInt(diffInSeconds / 3600);
  const minutes = parseInt((diffInSeconds % 3600) / 60);
  const seconds = parseInt(diffInSeconds % 60);

  return (hours ? hours + (hours > 1 ? ' hours ' : ' hour ') : '') +
    (minutes ? minutes + ' min. ' : '') +
    seconds + ' sec.';
}

function getMessage(disableNextDay, excludedDates) {
  const now = getDateInTimeZone(timeZone);

  const day = now.getDay();
  const hour = now.getHours();

  const d = ('0' + now.getDate()).slice(-2);
  const m = ('0' + (now.getMonth() + 1)).slice(-2);
  const Y = now.getFullYear();

  if (excludedDates.indexOf([d, m, Y].join('-')) !== -1) {
    return `Shipping time: ${getshipping_time ? getshipping_time.innerText : ''}`;
  }

  const orderTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0);
  const diffInSeconds = parseInt((orderTime.getTime() - now.getTime()) / 1000);
  let timeLeft = getTimeLeft(diffInSeconds);

  if (day >= 1 && day <= 4 && diffInSeconds > 0) {
    return '<span>Order now:</span> shipping in ' + timeLeft;
  }

  if (disableNextDay && (diffInSeconds <= 0 || (day === 6 || day === 0))) {
    return '';
  }

  switch (day) {
    case 0:
    case 1:
    case 2:
    case 3:
    case 4:
      timeLeft = getTimeLeft(diffInSeconds + 86400);
      return '<span><b>Order now:</b></span> shipping in ' + timeLeft;
    case 5:
      if (diffInSeconds > 0) {
        return 'Order now: ' + timeLeft;
      } else {
        return '<span><b>Order now:</b></span> shipping on Monday';
      }
    case 6:
      return `Shipping time: ${getshipping_time ? getshipping_time.innerText : ''}`;
  }
}

// Display the shipping message only for Central Time
if (element) {
  element.innerHTML = getMessage(disableNextDay, excludedDates);
  setInterval(function () {
    element.innerHTML = getMessage(disableNextDay, excludedDates);
  }, 1000);
}

            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
           
            // To trigger the Event
            document.dispatchEvent(custom_addToCart);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
